'use client';

/**
 * @packageDocumentation
 * @category Component
 */

import { FinalCtaSection } from '@pieleaf/app/[lang]/home/sections/final-cta';
import { HeroSection } from '@pieleaf/app/[lang]/home/sections/hero';
import { HowItWorksSection } from '@pieleaf/app/[lang]/home/sections/how-it-works';
import { ProduceShowcaseSection } from '@pieleaf/app/[lang]/home/sections/produce-showcase';
import { SourcingSection } from '@pieleaf/app/[lang]/home/sections/sourcing';

export const Home = () => (
  <>
    <HeroSection />
    <HowItWorksSection />
    <ProduceShowcaseSection />
    <SourcingSection />
    <FinalCtaSection />
  </>
);
